import api from '../../api'
const recurrenceAPI = api.create('recurrence')

const get = async ({ penaltyId = '' }) => {
  return await recurrenceAPI.get(`/penalties/${penaltyId}`)
}

const create = async ({ ...params }) => {
  return await recurrenceAPI.post(`/penalties`, params)
}

export default {
  get,
  create,
}
